<template>
  <div class="global-settings">
    <Background class="-slim"></Background>
    <div class="row  mt-xs  mb-m  pos-relative">
      <div class="col-16  col-md-24">
        <h2 class="h2  mb-0  mt-ß  font-weight-normal  color-white">{{ $t('globalSettings.headline') }}</h2>
      </div>
    </div>
    <ProfitCenters />
  </div>
</template>

<script>
import Background from '@/components/atoms/Background.vue';
import ProfitCenters from '@/components/modules/ProfitCenters.vue';

export default {
  name: 'GlobalSettings',
  components: {
    Background,
    ProfitCenters,
  },
};
</script>
